import { createContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  normalizeCanViewReports,
  normalizeCanViewInference,
  normalizeCanViewCdp,
  normalizeIsAdmin,
} from '../utils/authPermissions';
import { clearStoredActiveProject } from '../utils/activeProjectStorage';

export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return localStorage.getItem('accessToken') ? true : false;
  });
  const [email, setEmail] = useState(() => {
    return localStorage.getItem('email') || '';
  });

  const [user_id, setUserId] = useState(() => {
    return localStorage.getItem('user_id') || null;
  });

  const [canViewReports, setCanViewReports] = useState(() => {
    return localStorage.getItem('can_view_reports') === 'true';
  });

  const [canViewInference, setCanViewInference] = useState(() => {
    return localStorage.getItem('can_view_inference') === 'true';
  });

  const [canViewCdp, setCanViewCdp] = useState(() => {
    return localStorage.getItem('can_view_cdp') === 'true';
  });

  const [isAdmin, setIsAdmin] = useState(() => {
    return localStorage.getItem('is_admin') === 'true';
  });

  const login = (
    token,
    user_id,
    email,
    can_view_reports,
    can_view_inference,
    is_admin,
    can_view_cdp
  ) => {
    const normalizedCanViewReports = normalizeCanViewReports(can_view_reports);
    const normalizedCanViewInference = normalizeCanViewInference(can_view_inference);
    const normalizedIsAdmin = normalizeIsAdmin(is_admin);
    // Временно: если бэкенд не отдаёт can_view_cdp — используем can_view_inference
    const normalizedCanViewCdp = normalizeCanViewCdp(
      can_view_cdp !== undefined ? can_view_cdp : can_view_inference
    );

    localStorage.setItem('accessToken', token);
    localStorage.setItem('user_id', user_id);
    localStorage.setItem('email', email);
    localStorage.setItem('can_view_reports', String(normalizedCanViewReports));
    localStorage.setItem('can_view_inference', String(normalizedCanViewInference));
    localStorage.setItem('can_view_cdp', String(normalizedCanViewCdp));
    localStorage.setItem('is_admin', String(normalizedIsAdmin));
    setEmail(email || '');
    setUserId(user_id);
    setCanViewReports(normalizedCanViewReports);
    setCanViewInference(normalizedCanViewInference);
    setCanViewCdp(normalizedCanViewCdp);
    setIsAdmin(normalizedIsAdmin);
    setIsAuthenticated(true);
  };

  const logout = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('user_id');
    localStorage.removeItem('email');
    localStorage.removeItem('can_view_reports');
    localStorage.removeItem('can_view_inference');
    localStorage.removeItem('can_view_cdp');
    localStorage.removeItem('is_admin');
    // Выбранный проект принадлежит учётке — не оставляем его следующей сессии
    clearStoredActiveProject();
    setEmail('');
    setUserId(null);
    setCanViewReports(false);
    setCanViewInference(false);
    setCanViewCdp(false);
    setIsAdmin(false);
    setIsAuthenticated(false);
    navigate('/auth');
  };

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        user_id,
        email,
        canViewReports,
        canViewInference,
        canViewCdp,
        isAdmin,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
